import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { LinkContainer } from "react-router-bootstrap";
import React, { useState } from "react";
import offerDescription from "../OfferDescription.jsx";
import {Kachel3} from "../Offer";
import Accordion from "react-bootstrap/Accordion";
import OfferImg1 from "../../assets/threeGirlspixabay.jpg";
import SEO from "../SEO";

export default function Retreats() {
    const [setMatches] = useState(window.innerWidth);
    window.addEventListener("resize", checkSize);

    function checkSize() {
        setMatches(window.innerWidth);
    }
    return (
        <>
            <SEO
                title="Yoga Retreats in Bayern | Sylke Heuer"
                description="Yoga Retreats mit Yoga, Natur und Genuss. Nimm dir eine bewusste Auszeit vom Alltag und tanke neue Energie bei einem besonderen Yogawochenende in Bayern."
            />
            <section className="offerSec">
                <h4 className="introHeader">{offerDescription[0].title}</h4>
                <div className="intro">{offerDescription[0].body}</div>
                <h2 id="offer">Angebot</h2>
                        <Card className="cardOfferHeight">
                            <Card.Img className="cardImageDetail3" variant="top" src={OfferImg1} />
                            <Card.Body className="cardBodyPadding">
                                <Card.Title>{Kachel3.header}</Card.Title>
                                <br></br>
                                <Card.Text>
                                    In meinen Yogastunden verbinde ich achtsame Asanas mit Atemtechniken und meditativen Elementen. Yoga wirkt dabei auf allen Ebenen: Er macht den Körper beweglicher, beruhigt den Geist und öffnet einen Raum für Klarheit, Tiefe und neue Perspektiven. Ein Yoga Wochenende schenkt dir Zeit – für dich, für Ruhe, für bewusste Bewegung und echte Erholung.
                                </Card.Text>
                            </Card.Body>
                <Accordion className="accordionPadding">
                        <Accordion.Item eventKey="0" className="accordionMargin">
                            <Accordion.Header>{Kachel3.accordionHeader1}</Accordion.Header>
                            <Accordion.Body>
                                {Kachel3.description1}
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="1" className="accordionBorderTop">
                            <Accordion.Header>{Kachel3.accordionHeader2}</Accordion.Header>
                            <Accordion.Body>
                                {Kachel3.description2}
                            </Accordion.Body>
                        </Accordion.Item>
                </Accordion>
                        </Card>


                <LinkContainer to={`/`}>
                     <Button>Zurück</Button>
                 </LinkContainer>
            </section>
        </>
    );
}
